import React from 'react';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ShieldCheckSolidIcon(props) {
  return <FontAwesomeIcon icon={faShieldCheck} {...props} />;
}
